<template>
    <main class="page-container">
        <div v-if="isDraft" class="draft-warning-banner">
            <a-glyph name="attention2" />
            <span>THIS IS A DRAFT LINK: DO NOT publish or share externally.</span>
            <a-glyph name="attention2" />
        </div>

        <div class="page">
            <component
                v-bind="slice.data"
                :is="getComponent(slice.name)"
                v-for="(slice, position) in slices"
                :key="slice.id || `${slice.name}-${position}`"
            />
        </div>
    </main>
</template>

<script>
import { merge } from 'lodash-es';
import { defineComponent } from 'vue';
import AGlyph from '@core/components/glyph/glyph.vue';
import analytics from '@core/mixins/analytics.js';
import { registerSlices } from '@utils/resolve-nested-slices';
import '@core/styles/sections/pages.pcss';

export default defineComponent({
    name: 'PagesComponent',

    components: {
        AGlyph,
    },

    mixins: [analytics],

    data() {
        return {
            componentsRegistry: {},
        };
    },

    computed: {
        page() {
            return this.$store.state.pages.page;
        },
        slices() {
            const page = this.page.body || [];
            return page.map((item) => {
                const translations = item.data?.translations || {};
                const data = merge({}, item.data, translations);
                return { ...item, data };
            });
        },
        isDraft() {
            return !this.page.is_published;
        },
    },

    created() {
        registerSlices({
            pageBody: this.$store.state.pages.page.body,
            sectionResolver: (fullname) => fullname.startsWith('s-acronis-scs') ? 'scs' : 'pages',
            componentRegistrar: (name, component) => {
                this.componentsRegistry[name] = component;
            },
        });
    },

    methods: {
        getComponent(name) {
            return this.componentsRegistry[name] || null;
        },
    },
});
</script>

<style lang="postcss" scoped>
.page {
    position: relative;
}
</style>
